export default "__VITE_ASSET__45abd4ef__"